module.exports = __webpack_public_path__ + "img/58800.a3851aaf.jpg";